export const Obsession = {
    // Header
    title:"@Obsession",
    subtitle:"Unity | 2D",
    genre:"Life Sim",

    //Hero
    poster:"/Thumbnails/@Obsession_Thumbnail.png",
    releaseDate:"December 2023",
    studioName:"",
    teamSize:"4 Programmers and 3 Artists",
    platforms:"PC",
    responsiblities:[
        "Developed the Computer features"
    ],
    engine:"Unity",
    projectLength:"~4 Months",

    //Description
    desc:[
        `Play as an up-and-coming streamer/youtuber!\nYou must manage the time throughout the day to keep yourself healthy, and keep your subscribers happy.`,
        ``,
        `\nHowever, some fans are a bit too much, can you keep your cool when the strange things and creepy messages start coming?`,
    ],
    img:[
        "/Games/Obsession/@Obsession_IntroPhoto.png", "/Games/Obsession/@Obession_Computer1.png", 

    ],
    contributions:[
        `Developed the Computer features like Streaming, Making a Video and Upgrades`,
        `Implemented an outline on clickable objects that appears while hovering`,
    ],


    //Home Screen Hero
    thumbnail:"/Thumbnails/@Obsession_Thumbnail.png",
    shortDesc:`2D Life Simulator game built in Unity Game Engine.\nPlay through the daily life as a Streamer/Youtuber, but beware of increasingly obsessed fans!`,
    badge:"./Project Badges/unity-csharp.svg",
    url:"/projects/@Obsession",
    type:"Games",

    //Special Sections
    downloadable:"yes",
    credits:"",
    awards:"",
    awardImg:[

    ],

    //Links
    githubURL:"",
    itchioURL:"https://austereinsomniac.itch.io/obsession",
    itchioEmbedURL:"https://itch.io/embed/2322295",
    steamURL:"",


}